<template>
    <div class="sale-goods-item-comp" v-if="showItem">
        <div class="lf-sec">
            <div class="goods-icon">
                <lazy-image v-if="saleGoods.img" :style="{ 'border-radius': '0.375rem' }" :src="filterImg(saleGoods.img)"></lazy-image>
            </div>
            <div class="goods-info">
                <div class="goods-name ellipsis">{{ `${saleGoods.s_name}` }}</div>
                <div class="goods-price">
                    <span class="sp1">¥</span>
                    <span class="sp2">{{ saleGoods.current_price }}</span>
                </div>
            </div>
        </div>
        <div class="rg-sec" @click="buy">立即购买</div>
    </div>
</template>
<script>
import { getCookieToken, canPlayGame } from '@/utils/auth'
import config from '@/http/config'

export default {
    name: 'SaleGoodsItem',
    props: {
        saleGoods: {
            type: Object,
            default: () => ({})
        },
        wxInfo: {
            type: Object,
            default: () => ({})
        },
        zfbInfo: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        showItem() {
            if (this.saleGoods.mode == 1) {
                let gid_sid = this.$store.state.vipInfo.gid_sid
                if (gid_sid instanceof Object) {
                    return gid_sid[this.saleGoods.g_id] == this.saleGoods.id ? false : true
                } else {
                    return true
                }
            } else {
                return true
            }
        }
    },
    methods: {
        filterImg(value) {
            return this.$Utils.filterImgUrl(value, '50x50')
        },
        buy() {
            if (!getCookieToken()) {
                return this.$Login.show()
            }
            if (!canPlayGame(this)) {
                return false
            }
            let data = {}
            if (this.saleGoods.mode == 3) {
                data = {
                    channel: this.$store.state.clientInfo.channel,
                    gName: this.saleGoods.s_name,
                    gid: this.saleGoods.shop_goods_id, // 商城商品的id
                    gsid: this.saleGoods.relation_id,
                    img: this.saleGoods.img,
                    nums: 1,
                    payBay: '',
                    location: 'box_family',
                    goods_name: this.saleGoods.name,
                    current_price: this.saleGoods.current_price,
                    wxInfo: this.wxInfo,
                    zfbInfo: this.zfbInfo,
                    spType: 1,
                    goods_id: this.goods_id // 关联的游戏商品id
                }
                const url = `token=${getCookieToken()}&targetUrl=${encodeURIComponent(config.WEB_DOMAIN + `/custom_detail.html?custom_page_shop_id=${data.gid}&s_id=${data.gsid}`)}`
                window.open(`${config.WEB_DOMAIN}/redirect.html?${url}`, '_blank')
            } else if (this.saleGoods.mode == 1) {
                data = {
                    channel: this.$store.state.clientInfo.channel,
                    goods_name: this.saleGoods.name,
                    gName: this.saleGoods.s_name,
                    current_price: this.saleGoods.current_price,
                    wxInfo: this.wxInfo,
                    zfbInfo: this.zfbInfo,
                    spType: 2,
                    g_id: this.saleGoods.id, // 独享规格的id
                    goods_id: this.goods_id, // 关联的游戏商品id
                    client_ip: this.$store.state.client_ip
                }
                this.$PayGoods.show(data)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.sale-goods-item-comp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    height: 90px;
    padding: 0 20px;
    background: @bg-color-1E;

    .lf-sec {
        display: flex;
        flex: 0;

        .goods-icon {
            width: 50px;
            height: 50px;
            margin-right: 6px;
        }

        .goods-info {
            width: 244px;
            padding-top: 6px;

            .goods-name {
                font-size: 14px;
                line-height: 14px;
                color: @color-txt-high;
                margin-bottom: 6px;
            }

            .goods-price {
                color: @color-number-yellow2;
                .sp1 {
                    font-size: 12px;
                    margin-right: 3px;
                }

                .sp2 {
                    font-size: 18px;
                }
            }
        }
    }

    .rg-sec {
        cursor: pointer;
        flex-shrink: 0;
        font-size: 14px;
        color: @main-green-color;
        width: 80px;
        height: 30px;
        background: url(../../../assets/jb-bd.png) center/100% no-repeat;
        text-align: center;
        padding-top: 5px;

        &:hover {
            background: linear-gradient(90deg, #00f14e, #02cb8a);
            color: @bg-color-00;
            border-radius: 15px;
        }
    }
}
</style>
